const view = path => ({
  name: path,
  props: true,
  /* webpackChunkName: "routes" */
  /* webpackMode: "lazy-once" */
  component: () => import(`@/views/${path}.vue`)
});

const mobileView = path => ({
  name: path,
  props: true,
  /* webpackChunkName: "routes" */
  /* webpackMode: "lazy-once" */
  component: () => import(`@/components/mobile/${path}.vue`)
});
const components = path => ({
  name: path,
  props: true,
  /* webpackChunkName: "routes" */
  /* webpackMode: "lazy-once" */
  component: () => import(`@/components/${path}.vue`)
});

export default [
  {
    ...components("TermsAndConditions"),
    name: "TermsAndConditions",
    path: "/terms-and-conditions",
    meta: {
      ignoreGate: true,
      requiresAuth: false
    }
  },
  {
    ...components("PrivacyPolicy"),
    name: "PrivacyPolicy",
    path: "/privacy-policy",
    meta: {
      ignoreGate: true,
      requiresAuth: false
    }
  },
  {
    ...components("ConnectPolicy"),
    name: "ConnectPolicy",
    path: "/cc-connect-policy",
    meta: {
      ignoreGate: true,
      requiresAuth: false
    }
  },
  {
    ...view("events/PublicEvents"),
    name: "PublicEvents",
    path: "/cc-events",
    meta: {
      ignoreGate: false,
      requiresAuth: false,
      isPublicPage: true,
      showSidebars: false
    }
  },
  {
    ...view("events/PublicPastEvents"),
    name: "PublicPastEvents",
    path: "/cc-past-events",
    meta: {
      ignoreGate: false,
      requiresAuth: false,
      isPublicPage: true,
      showSidebars: false
    }
  },
  {
    ...view("Settings/ForgotPassword"),
    name: "ForgotPassword",
    path: "/forgot-password",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    path: "/",
    redirect: { name: "PersonalWall" },
    meta: { showSidebars: false }
  },
  {
    ...view("Settings/UserFirstSettings"),
    path: "/settings/user-first-settings",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/SetPassword"),
    path: "/settings/set-password/:token",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/CompanyFirstSettings"),
    path: "/settings/company-first-settings",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/ResendToken"),
    path: "/settings/resend-token/:token",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/MobileRedirect"),
    path: "/mobile-redirect",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/ForgotPassword"),
    name: "forgotPassword",
    path: "/settings/forgot-password",
    meta: {
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...view("Settings/ResetPassword"),
    name: "resetPassword",
    path: "/settings/reset-password/",
    meta: {
      ignoreGate: true,
      requiresAuth: false,
      showSidebars: false
    }
  },
  {
    ...components("PaymentSuccess"),
    name: "PaymentSuccess",
    path: "/payment-success",
    meta: {
      requiresAuth: true,
      showSidebars: false
    }
  },
  {
    ...components("PaymentFailed"),
    name: "PaymentFailed",
    path: "/payment-failed",
    meta: {
      requiresAuth: true,
      showSidebars: false
    }
  },
  {
    ...components("search/GlobalSearch"),
    name: "GlobalSearch",
    path: "/search",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("landing/Homepage"),
    name: "Homepage",
    path: "/homepage",
    meta: {
      requiresAuth: false
    }
  },
  {
    ...view("auth/SignIn"),
    name: "signIn",
    path: "/sign-in",
    meta: {
      requiresAuth: false
    }
  },
  {
    ...view("auth/SignUp"),
    path: "/sign-up",
    meta: {
      requiresAuth: false
    }
  },
  {
    ...view("auth/SetPassword"),
    path: "/set-password/:token",
    meta: {
      requiresAuth: true
    }
  },

  {
    ...view("pages/CompanyWall"),
    name: "CompanyWall",
    path: "/company-wall/:companyId",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/PersonalWall"),
    name: "PersonalWall",
    path: "/personal-wall",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/MemberWall"),
    name: "MemberWall",
    path: "/personal-wall/:customerId",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...components("newsFeed/MemberPost"),
    name: "MemberPost",
    path: "/personal-wall/post/:id",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...components("newsFeed/SharedPost"),
    name: "SharedPost",
    path: "/personal-wall/shared-post/:id",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...mobileView("MobileBookedEvents"),
    path: "/booked-events/",
    name: "BookedEvents",
    meta: {
      requiresAuth: true,
      showSidebars: false
    }
  },
  {
    ...mobileView("MobileUpcomingEvents"),
    path: "/upcoming-events/",
    name: "UpcomingEvents",
    meta: {
      requiresAuth: true,
      showSidebars: false
    }
  },
  {
    ...mobileView("MobileLatestCCUpdates"),
    path: "/cc-updates/",
    name: "CCUpdates",
    meta: {
      requiresAuth: true,
      showSidebars: false
    }
  },
  {
    ...view("events/AllEvents"),
    path: "/all-events/",
    name: "ccAllEvents",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("events/MyEvents"),
    path: "/my-events/",
    name: "ccMyEvents",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("events/PastEvents"),
    path: "/past-events",
    name: "pastEvents",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("events/previousEdition/ImageGallery"),
    path: "/event-photo-archive",
    name: "ImageGallery",
    meta: { requiresAuth: true, showSidebars: true }
  },
  {
    ...view("events/AllAwards"),
    path: "/all-awards",
    name: "allAwards",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("events/previousEdition/VideoGallery"),
    path: "/event-video-archive",
    name: "VideoGallery",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("events/previousEdition/PDFGuide"),
    path: "/event-guide-archive",
    name: "PDFGuide",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/MediaChannels/MediaChannels"),
    name: "MediaChannels",
    path: "/media-channels",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/MediaArchive/MediaArchive"),
    name: "MediaArchive",
    path: "/media-archive",
    redirect: { name: "VideoArchive" },
    meta: {
      requiresAuth: true,
      showSidebars: true
    },
    children: [
      {
        ...view("pages/MediaArchive/VideoArchive"),
        name: "VideoArchive",
        path: "/media-archive/video",
        meta: {
          requiresAuth: true,
          showSidebars: true
        }
      },
      {
        ...view("pages/MediaArchive/ImageArchive"),
        name: "ImageArchive",
        path: "/media-archive/gallery",
        meta: {
          requiresAuth: true,
          showSidebars: true
        }
      },  
      {
        ...view("pages/MediaArchive/PostGuideArchive"),
        name: "PostGuideArchive",
        path: "/media-archive/post-guide",
        meta: {
          requiresAuth: true,
          showSidebars: true
        }
      }
    ]
  },
  {
    ...view("pages/MediaArchive/MediaArchive"),
    name: "PublicMediaArchive",
    path: "/events-media-archive",
    redirect: { name: "PublicVideoArchive" },
    meta: {
      requiresAuth: false,
      showSidebars: false
    },
    children: [
      {
        ...view("pages/MediaArchive/VideoArchive"),
        name: "PublicVideoArchive",
        path: "/events-media-archive/video",
        meta: {
          requiresAuth: false,
          showSidebars: false
        }
      },
      {
        ...view("pages/MediaArchive/ImageArchive"),
        name: "PublicImageArchive",
        path: "/events-media-archive/gallery",
        meta: {
          requiresAuth: false,
          showSidebars: false
        }
      },  
      {
        ...view("pages/MediaArchive/PostGuideArchive"),
        name: "PublicMagazineArchive",
        path: "/events-media-archive/post-guide",
        meta: {
          requiresAuth: false,
          showSidebars: false
        }
      }
    ]
  },
  {
    ...view("pages/Messages/Messages"),
    name: "Messages",
    path: "/messages",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Messages/CurrentMessage"),
    path: "/messages/:chatRoomId",
    name: "currentMessage",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Messages/Blacklist"),
    path: "/blacklist",
    name: "blacklist",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },

  // {
  //   ...view("events/previousEdition/MagazineArchive"),
  //   path: "/event-magazine-archive",
  //   name: "MagazineArchive",
  //   meta: {
  //     requiresAuth: true
  //   }
  // },

  {
    ...view("events/StandardEvents"),
    name: "standardEvent",
    path: "/events/:slug/:eventId",
    redirect: { name: "Info" },
    props: true,
    meta: {
      requiresAuth: true,
      showSidebars: true
    },
    children: [
      {
        ...view("events/StandardEvent/Info"),
        name: "Info",
        path: "/events/:slug/:eventId/info",
        props: true,
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Map"),
        name: "Map",
        path: "/events/:slug/:eventId/map",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/EventBookingDetails"),
        name: "BookEventDetails",
        path: "/events/:slug/:eventId/book-event-details",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Agenda"),
        name: "Agenda",
        path: "/events/:slug/:eventId/agenda",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Venue"),
        name: "Venue",
        path: "/events/:slug/:eventId/venue",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Accommodation"),
        name: "Accommodation",
        path: "/events/:slug/:eventId/accommodation",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Speakers"),
        name: "Speakers",
        path: "/events/:slug/:eventId/speakers",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Exhibitors"),
        name: "Exhibitors",
        path: "/events/:slug/:eventId/exhibitors",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/BookedTables"),
        name: "Booked Tables",
        path: "/events/:slug/:eventId/booked-tables",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/MeetingRooms"),
        name: "Meeting Rooms",
        path: "/events/:slug/:eventId/meeting-rooms",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/Media"),
        name: "Media",
        path: "/events/:slug/:eventId/media",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/ParticipantCompanies"),
        name: "Companies",
        path: "/events/:slug/:eventId/participant-companies",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/BecomeSponsor"),
        name: "BecomeSponsorEvent",
        path: "/events/:slug/:eventId/become-sponsor",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/BecomePannelist"),
        name: "BecomePannelist",
        path: "/events/:slug/:eventId/become-pannelist",
        meta: { requiresAuth: true, showSidebars: true }
      }
    ]
  },
  {
    ...view("events/PublicEventContainer"),
    path: "/cc-events/:slug/:eventId",
    name: "PublicEventContainer",
    redirect: { name: "PublicInfo" },
    props: true,
    meta: {
      requiresAuth: false,
      showSidebars: false
    },
    children: [
      {
        ...view("events/StandardEvent/Info"),
        name: "PublicInfo",
        path: "/cc-events/:slug/:eventId/info",
        props: true,
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Map"),
        name: "PublicMap",
        path: "/cc-events/:slug/:eventId/map",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Agenda"),
        name: "PublicAgenda",
        path: "/cc-events/:slug/:eventId/agenda",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Venue"),
        name: "PublicVenue",
        path: "/cc-events/:slug/:eventId/venue",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Accommodation"),
        name: "PublicAccommodation",
        path: "/cc-events/:slug/:eventId/accommodation",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Speakers"),
        name: "PublicSpeakers",
        path: "/cc-events/:slug/:eventId/speakers",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Exhibitors"),
        name: "PublicExhibitors",
        path: "/cc-events/:slug/:eventId/exhibitors",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/BookedTables"),
        name: "PublicBooked Tables",
        path: "/cc-events/:slug/:eventId/booked-tables",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/MeetingRooms"),
        name: "PublicMeeting Rooms",
        path: "/cc-events/:slug/:eventId/meeting-rooms",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/Media"),
        name: "PublicMedia",
        path: "/cc-events/:slug/:eventId/media",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/StandardEvent/ParticipantCompanies"),
        name: "PublicCompanies",
        path: "/cc-events/:slug/:eventId/participant-companies",
        meta: { requiresAuth: false, showSidebars: false }
      }
    ]
  },

  {
    ...view("events/PublicAwardContainer"),
    path: "/cc-awards/:slug/:awardId",
    name: "PublicAwardContainer",
    meta: { requiresAuth: false, showSidebars: false },
    redirect: { name: "AwardInfo" },
    props: true,
    children: [
      {
        ...view("events/awards/Info"),
        name: "PublicAwardInfo",
        path: "/cc-awards/:slug/:awardId/info",
        props: true,
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Map"),
        name: "PublicAwardMap",
        path: "/cc-awards/:slug/:awardId/map",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Agenda"),
        name: "PublicAwardAgenda",
        path: "/cc-awards/:slug/:awardId/agenda",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Categories"),
        name: "PublicAwardCategories",
        path: "/cc-awards/:slug/:awardId/categories",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Jury"),
        name: "PublicAwardJury",
        path: "/cc-awards/:slug/:awardId/jury",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Media"),
        name: "PublicAwardMedia",
        path: "/cc-awards/:slug/:awardId/media",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/TermsAndConditions"),
        name: "PublicAwardTerms&Conditions",
        path: "/cc-awards/:slug/:awardId/terms-and-conditions",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/Highlights"),
        name: "PublicAwardHighlights",
        path: "/cc-awards/:slug/:awardId/highlights",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/AwardWinners"),
        name: "PublicAwardWinners",
        path: "/cc-awards/:slug/:awardId/winners",
        meta: { requiresAuth: false, showSidebars: false }
      },
      {
        ...view("events/awards/AwardShortlisted"),
        name: "PublicAwardShortlisted",
        path: "/cc-awards/:slug/:awardId/shortlisted",
        meta: { requiresAuth: false, showSidebars: false }
      }
    ]
  },
  {
    ...view("events/awards/AwardSubmission"),
    name: "AwardSubmission",
    path: "/awards/:awardId/award-submissions/:submissionId",
    meta: { showSidebars: false, isDownloadRoute: true },
  },
  {
    ...view("events/GlobalAwards"),
    path: "/awards/:slug/:awardId",
    name: "globalAwardsEvents",
    meta: {
      requiresAuth: true,
      showSidebars: true
    },
    redirect: { name: "AwardInfo" },
    props: true,
    children: [
      {
        ...view("events/awards/Info"),
        name: "AwardInfo",
        path: "/awards/:slug/:awardId/info",
        props: true,
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Map"),
        name: "AwardMap",
        path: "/awards/:slug/:awardId/map",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Agenda"),
        name: "AwardAgenda",
        path: "/awards/:slug/:awardId/agenda",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Categories"),
        name: "AwardCategories",
        path: "/awards/:slug/:awardId/categories",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Jury"),
        name: "AwardJury",
        path: "/awards/:slug/:awardId/jury",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/StandardEvent/EventBookingDetails"),
        name: "BookAwardDetails",
        path: "/awards/:slug/:awardId/book-award-details",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Media"),
        name: "AwardMedia",
        path: "/awards/:slug/:awardId/media",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/TermsAndConditions"),
        name: "AwardTerms&Conditions",
        path: "/awards/:slug/:awardId/terms-and-conditions",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/Highlights"),
        name: "AwardHighlights",
        path: "/awards/:slug/:awardId/highlights",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/BecomeSponsor"),
        name: "BecomeSponsorAward",
        path: "/awards/:slug/:awardId/become-sponsor",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/EnterAward"),
        name: "EnterAward",
        path: "/awards/:slug/:awardId/enter-award",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/AwardWinners"),
        name: "AwardWinners",
        path: "/awards/:slug/:awardId/winners",
        meta: { requiresAuth: true, showSidebars: true }
      },
      {
        ...view("events/awards/AwardShortlisted"),
        name: "AwardShortlisted",
        path: "/awards/:slug/:awardId/shortlisted",
        meta: { requiresAuth: true, showSidebars: true }
      },
    ]
  },
  {
    ...view("pages/MeetingPlanner/MeetingPlanner"),
    name: "meetingPlanner",
    path: "/events/:slug/:eventId/meeting-planner",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Network/Network"),
    path: "/network",
    name: "network",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Members/MembersList"),
    path: "/members",
    name: "MembersList",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Notifications/AllNotifications"),
    path: "/notifications",
    name: "AllNotifications",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("pages/Notifications/Notification"),
    path: "/notifications/:id",
    name: "Notification",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("profile/UserProfileMenu"),
    path: "/profile-menu",
    name: "UserProfileMenu",
    meta: {
      requiresAuth: true,
      showSidebars: true
    }
  },
  {
    ...view("profile/UserProfile"),
    name: "UserProfile",
    path: "/profile",
    meta: { requiresAuth: true, showSidebars: false },
    children: [
      {
        ...view("profile/ProfilePage"),
        path: "/profile/:customerId?",
        name: "userProfilePage",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("profile/CompanyProfilePage"),
        path: "/company-profile/:companyId",
        name: "companyProfile",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/UserSettings"),
        path: "/settings/user-settings",
        name: "userSettings",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/UserChangePassword"),
        path: "/settings/change-password",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/Invoices"),
        name: "Settings/Invoices",
        path: "/settings/invoices",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/UserPrivacySettings"),
        path: "/settings/privacy-settings",
        name: "Settings/UserPrivacySettings",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/CompanySettings"),
        path: "/settings/company-settings",
        name: "Settings/CompanySettings",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/CompanyEmployees"),
        path: "/settings/company-employees",
        meta: { requiresAuth: true, showSidebars: false }
      },
      {
        ...view("Settings/InvoicePreview"),
        path: "/settings/:invoiceId/invoice-preview",
        meta: {
          requiresAuth: true,
          showSidebars: false
        }
      },
      {
        ...view("Settings/InvoicePreview"),
        name: "Settings/InvoiceDownload",
        path: "/settings/:invoiceId/download",
        meta: {
          requiresAuth: true,
          showSidebars: false
        }
      }
    ]
  },
  {
    ...view("NotAvailable"),
    path: "/not-available",
    name: "NotAvailable",
    meta: {
      requiresAuth: true,
      showSidebars: true,
    }
  },
  {
    ...view("NotFound"),
    path: "/:pathMatch(.*)*",
    meta: {
      requiresAuth: false,
      showSidebars: false,
      ignoreGate: true
    }
  }
];
